// extracted by mini-css-extract-plugin
module.exports = {"container":"TabSetComponent_container__2IAAm"};